<template lang="pug">
  .gcode-input-block
    inline-svg(:src="require('./google-auth-icon.svg')" width="32" height="32")
    slot
      input(type="text" autocomplete="one-time-code" name="one-time-code" @keydown.enter.prevent="onEnterDown" :value="value" @input="onInput" :placeholder="placeholder").form-control
    // :value="value" @input="onInput"
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import InlineSvg from 'vue-inline-svg';

@Component({
  name: "GoogleCodeInput",
  components: {InlineSvg},
  inheritAttrs: false
})
export default class GoogleCodeInput extends Vue {
  @Prop({default: ''})
  value: string

  @Prop({default: ''})
  placeholder: string

  onEnterDown($event) {
    this.$emit('keydown', $event);
  }

  // @Watch('value')
  // onValueUpdate(newVal) {
  //   this.internalValue = newVal;
  // }

  onInput(event) {
    this.$emit('input', event.target.value)
  }

}
</script>

<style scoped lang="less">
.gcode-input-block {
  display: grid;
  grid-gap: 15px;
  grid-template-columns: max-content auto;
  align-items: center;
}
</style>
